/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Surface_WebInputs */

const en_marketing_surface_web = /** @type {(inputs: Marketing_Surface_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web app`)
};

const es_marketing_surface_web = /** @type {(inputs: Marketing_Surface_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicación web`)
};

const fr_marketing_surface_web = /** @type {(inputs: Marketing_Surface_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application web`)
};

/**
* | output |
* | --- |
* | "Web app" |
*
* @param {Marketing_Surface_WebInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_surface_web = /** @type {((inputs?: Marketing_Surface_WebInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Surface_WebInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_surface_web(inputs)
	if (locale === "es") return es_marketing_surface_web(inputs)
	return fr_marketing_surface_web(inputs)
});